module.exports = __webpack_public_path__ + "static/img/UOOYAA_07_16.644db1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/06/UOOYAA_07_16.jpg
// module id = uNvw
// module chunks = 7